export default {
  cbam_news: "CBAM-Nachrichten",
  view_all_news: "Alle Nachrichten anzeigen",
  search_news: "Nachrichten suchen...",
  no_news: "Keine Nachrichten verfügbar",
  fetch_news_failed: "Nachrichten konnten nicht abgerufen werden",
};
